import Dictionary from "./Dictionary";
import "./App.css";
import icon from "./icon.png";

export default function App() {
  return (
    <div className="App">
      <h1>
        DiCTiONARY
        <img src={icon} className="logo" alt="logo-books" />
      </h1>
      <Dictionary />
      <br />
      <section>
        <a className="footer" href="/">
          Open-source
        </a>{" "}
        code by{" "}
        <a className="footer" href="/">
          Eliana Marques
        </a>{" "}
        and hosted on{" "}
        <a className="footer" href="/">
          Netlify
        </a>
      </section>
    </div>
  );
}
